module.exports = __webpack_public_path__ + "img/Path 4@3x.860fb8c4.png";